// Screen shake — accumulates a magnitude register that decays over time.
// Each frame the renderer queries getShakeOffset() and composes it with
// the camera translation when writing to app.stage.position.

let magnitude = 0;
let currentX = 0;
let currentY = 0;

const DECAY_PER_SECOND = 8;
const STOP_THRESHOLD = 0.15;

/** Bump the shake intensity. Use larger numbers (10–20) for hard impacts. */
export function shake(strength: number): void {
  magnitude = Math.max(magnitude, strength);
}

/** Roll the shake forward one frame, sampling a fresh random offset. */
export function updateShake(dt: number): void {
  if (magnitude < STOP_THRESHOLD) {
    magnitude = 0;
    currentX = 0;
    currentY = 0;
    return;
  }
  currentX = (Math.random() - 0.5) * 2 * magnitude;
  currentY = (Math.random() - 0.5) * 2 * magnitude;
  magnitude *= Math.exp(-DECAY_PER_SECOND * dt);
}

export function getShakeOffset(): { x: number; y: number } {
  return { x: currentX, y: currentY };
}
